/* eslint-disable no-unused-vars */
/* eslint-disable no-var */
/* eslint-disable one-var */
import React, { useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import toast from "react-hot-toast";
import { useQueryClient } from "@tanstack/react-query";
import { completeFacebookSetup } from "../../utils/requests-v2";
import { useBusinessContext } from "../../utils/Contexts/V2/BusinessContext";
import Spinner from "../../components/Spinner";
// import Button from "../../components/forms/Button";

const data = [
  {
    id: 1,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.75 2.75C2.75 2.08696 3.01339 1.45107 3.48223 0.982233C3.95107 0.513392 4.58696 0.25 5.25 0.25C5.91304 0.25 6.54893 0.513392 7.01777 0.982233C7.48661 1.45107 7.75 2.08696 7.75 2.75C7.75 3.41304 7.48661 4.04893 7.01777 4.51777C6.54893 4.98661 5.91304 5.25 5.25 5.25C4.58696 5.25 3.95107 4.98661 3.48223 4.51777C3.01339 4.04893 2.75 3.41304 2.75 2.75ZM11.2238 4.73L11.2762 4.77C11.8066 5.16313 12.471 5.33052 13.1243 5.23564C13.7776 5.14076 14.3669 4.7913 14.7635 4.26354C15.1601 3.73578 15.3319 3.07257 15.2413 2.41862C15.1508 1.76468 14.8052 1.17311 14.2801 0.773015C13.755 0.372915 13.0929 0.196771 12.4384 0.283021C11.7838 0.369272 11.19 0.710916 10.7864 1.23339C10.3829 1.75587 10.2024 2.41676 10.2843 3.07184C10.3662 3.72692 10.7039 4.323 11.2238 4.73ZM6.835 6.5C6.992 6.2027 7.20736 5.94013 7.46818 5.72799C7.72901 5.51584 8.02994 5.35849 8.35298 5.26534C8.67603 5.17218 9.01454 5.14514 9.34827 5.18584C9.68201 5.22654 10.0041 5.33413 10.2953 5.50218C10.5865 5.67024 10.8408 5.8953 11.043 6.1639C11.2452 6.43251 11.3911 6.73914 11.4721 7.06545C11.5531 7.39176 11.5674 7.73105 11.5142 8.06302C11.461 8.39499 11.3414 8.71282 11.1625 8.9975C10.8184 9.54516 10.2754 9.93814 9.64767 10.0939C9.01992 10.2496 8.35623 10.156 7.79603 9.83274C7.23584 9.50944 6.82275 8.98161 6.64354 8.36014C6.46433 7.73867 6.53296 7.07193 6.835 6.5ZM2.125 6.5H5.4625C5.24034 7.13445 5.19204 7.81679 5.3226 8.47621C5.45317 9.13562 5.75784 9.74808 6.205 10.25H5.875C5.23055 10.2499 4.60181 10.449 4.07486 10.82C3.5479 11.191 3.14847 11.7158 2.93125 12.3225C2.51167 12.154 2.11881 11.9253 1.765 11.6437C0.825 10.8875 0.25 9.77 0.25 8.375C0.25 7.87772 0.447544 7.40081 0.799175 7.04917C1.15081 6.69754 1.62772 6.5 2.125 6.5ZM12.125 10.25C12.7693 10.25 13.3978 10.4491 13.9246 10.8201C14.4513 11.1911 14.8505 11.7159 15.0675 12.3225C15.4925 12.1488 15.8863 11.9225 16.235 11.6437C17.175 10.8875 17.75 9.77 17.75 8.375C17.75 7.87772 17.5525 7.40081 17.2008 7.04917C16.8492 6.69754 16.3723 6.5 15.875 6.5H12.5375C12.675 6.89125 12.75 7.3125 12.75 7.75C12.7512 8.67264 12.411 9.56311 11.795 10.25H12.125ZM13.8588 12.66C13.95 12.88 14 13.1225 14 13.375C14 14.77 13.4263 15.8875 12.485 16.6437C11.5588 17.3875 10.3162 17.75 9 17.75C7.68375 17.75 6.44125 17.3875 5.515 16.6437C4.575 15.8875 4 14.77 4 13.375C3.99934 13.1286 4.04739 12.8845 4.14138 12.6567C4.23538 12.4289 4.37346 12.2219 4.5477 12.0477C4.72194 11.8735 4.92891 11.7354 5.15669 11.6414C5.38447 11.5474 5.62859 11.4993 5.875 11.5H12.125C12.4964 11.4999 12.8594 11.6101 13.1681 11.8166C13.4767 12.0232 13.7171 12.3167 13.8588 12.66Z"
          fill="#006187"
        />
      </svg>
    ),
    description:
      "Reach more customers on Facebook & Instagram by connecting your business page with Thryve’s powerful lead generation tool.",
  },
  {
    id: 2,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 19 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.33366 0.333313C9.16699 0.333313 10.667 1.83331 10.667 3.66665C10.667 5.49998 9.16699 6.99998 7.33366 6.99998C5.50033 6.99998 4.00033 5.49998 4.00033 3.66665C4.00033 1.83331 5.50033 0.333313 7.33366 0.333313ZM13.167 14.5L14.667 15.975C15.0837 16.3916 15.667 16.0583 15.667 15.5666V12L18.0003 9.16665C18.0932 9.04284 18.1497 8.89562 18.1636 8.74148C18.1775 8.58735 18.1482 8.43239 18.079 8.29397C18.0098 8.15555 17.9034 8.03913 17.7718 7.95777C17.6401 7.87641 17.4884 7.83331 17.3337 7.83331H11.5003C10.8337 7.83331 10.417 8.66665 10.8337 9.16665L13.167 12V14.5ZM11.5003 12.5833L9.58366 10.25C9.25033 9.83331 9.08366 9.33331 9.08366 8.83331C8.50033 8.66665 7.91699 8.66665 7.33366 8.66665C3.66699 8.66665 0.666992 10.1666 0.666992 12V13.6666H11.5003V12.5833Z"
          fill="#006187"
        />
      </svg>
    ),
    description:
      "Capture more leads & grow your business with Facebook Lead Ads integrated seamlessly with Thryve.",
  },
  {
    id: 3,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8333 0.5H2.16667C1.25 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.25 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V2.16667C15.5 1.25 14.75 0.5 13.8333 0.5ZM4.66667 12.1667C4.20833 12.1667 3.83333 11.7917 3.83333 11.3333V8.83333C3.83333 8.375 4.20833 8 4.66667 8C5.125 8 5.5 8.375 5.5 8.83333V11.3333C5.5 11.7917 5.125 12.1667 4.66667 12.1667ZM8 12.1667C7.54167 12.1667 7.16667 11.7917 7.16667 11.3333V10.5C7.16667 10.0417 7.54167 9.66667 8 9.66667C8.45833 9.66667 8.83333 10.0417 8.83333 10.5V11.3333C8.83333 11.7917 8.45833 12.1667 8 12.1667ZM8 8C7.54167 8 7.16667 7.625 7.16667 7.16667C7.16667 6.70833 7.54167 6.33333 8 6.33333C8.45833 6.33333 8.83333 6.70833 8.83333 7.16667C8.83333 7.625 8.45833 8 8 8ZM11.3333 12.1667C10.875 12.1667 10.5 11.7917 10.5 11.3333V4.66667C10.5 4.20833 10.875 3.83333 11.3333 3.83333C11.7917 3.83333 12.1667 4.20833 12.1667 4.66667V11.3333C12.1667 11.7917 11.7917 12.1667 11.3333 12.1667Z"
          fill="#006187"
        />
      </svg>
    ),
    description:
      "Save time and effort by creating and managing your Facebook Lead Ads on Thryve.",
  },
  {
    id: 4,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 14 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.99967 17.3333C5.06912 16.8472 3.47523 15.7394 2.21801 14.01C0.960786 12.2805 0.332453 10.3605 0.333008 8.24996V3.16663L6.99967 0.666626L13.6663 3.16663V8.24996C13.6663 10.3611 13.0377 12.2813 11.7805 14.0108C10.5233 15.7402 8.92967 16.8477 6.99967 17.3333ZM5.33301 12.3333H8.66634C8.90245 12.3333 9.10051 12.2533 9.26051 12.0933C9.42051 11.9333 9.50023 11.7355 9.49967 11.5V8.99996C9.49967 8.76385 9.41967 8.56579 9.25967 8.40579C9.09967 8.24579 8.9019 8.16607 8.66634 8.16663V7.33329C8.66634 6.87496 8.50301 6.48246 8.17634 6.15579C7.84967 5.82913 7.45745 5.66607 6.99967 5.66663C6.54134 5.66663 6.14884 5.82996 5.82217 6.15663C5.49551 6.48329 5.33245 6.87551 5.33301 7.33329V8.16663C5.0969 8.16663 4.89884 8.24663 4.73884 8.40663C4.57884 8.56663 4.49912 8.7644 4.49967 8.99996V11.5C4.49967 11.7361 4.57967 11.9341 4.73968 12.0941C4.89967 12.2541 5.09745 12.3338 5.33301 12.3333ZM6.16634 8.16663V7.33329C6.16634 7.09718 6.24634 6.89913 6.40634 6.73913C6.56634 6.57913 6.76412 6.4994 6.99967 6.49996C7.23579 6.49996 7.43384 6.57996 7.59384 6.73996C7.75384 6.89996 7.83356 7.09774 7.83301 7.33329V8.16663H6.16634Z"
          fill="#006187"
        />
      </svg>
    ),
    description:
      "Rest assured that your Facebook Business Page and customer data are protected with Thryve’s secure integration.",
  },
  {
    id: 5,
    icon: (
      <svg
        width="18"
        height="18"
        viewBox="0 0 20 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.4997 16.8333L14.1663 14.5V14.6667H0.833008V12.3333C0.833008 11.8611 0.954674 11.4269 1.19801 11.0308C1.44134 10.6347 1.76412 10.3328 2.16634 10.125C3.02745 9.69444 3.90245 9.37139 4.79134 9.15583C5.68023 8.94028 6.58301 8.83278 7.49967 8.83333C7.68023 8.83333 7.85745 8.83694 8.03134 8.84417C8.20523 8.85139 8.37523 8.86167 8.54134 8.875L7.66634 8H7.49967C6.58301 8 5.79829 7.67361 5.14551 7.02083C4.49273 6.36805 4.16634 5.58333 4.16634 4.66667V4.5L1.16634 1.5L2.35384 0.3125L17.6872 15.6458L16.4997 16.8333ZM14.9997 9.66667V7.16667H12.4997V5.5H14.9997V3H16.6663V5.5H19.1663V7.16667H16.6663V9.66667H14.9997ZM10.4997 6.08333L6.08301 1.66667C6.29134 1.55556 6.51717 1.47222 6.76051 1.41667C7.00384 1.36111 7.25023 1.33333 7.49967 1.33333C8.41634 1.33333 9.20106 1.65972 9.85384 2.3125C10.5066 2.96528 10.833 3.75 10.833 4.66667C10.833 4.91667 10.8052 5.16333 10.7497 5.40667C10.6941 5.65 10.6108 5.87556 10.4997 6.08333Z"
          fill="#006187"
        />
      </svg>
    ),
    description:
      "Your control and flexibility matter. You have the option to disconnect your Facebook Business Page from Thryve anytime you want.",
  },
];

export default function ConnectFacebook() {
  const [searchParams, setSearchParams] = useSearchParams(
    new URLSearchParams({ to: "/" })
  );
  const navigate = useNavigate();

  const {
    business: {
      connectedFacebookPages: {
        data: connectedFacebookPages,
        isLoading: isLoadingFacebookPages,
      },
    },
  } = useBusinessContext();

  const queryClient = useQueryClient();

  // eslint-disable-next-line no-unused-vars
  const loginWithFacebook = () => {
    window.FB.login(
      (response) => {
        console.log(response);

        if (response.status === "connected") {
          const payload = {
            access_token: response.authResponse.accessToken,
          };
          completeFacebookSetup({ data: payload })
            .then(async () => {
              toast.success("Successfully linked your Facebook page");
              await queryClient.invalidateQueries(["/facebook-pages"]);
              navigate(searchParams.get("to"));
            })
            .catch((error) => {
              console.error(error);
              toast.error("Could not complete setup. Please try again.");
            });
        } else {
          console.error(response);
          toast.error("Could not complete setup. Please try again.");
        }
      },
      {
        config_id: process.env.REACT_APP_FACEBOOK_CONFIG_ID,
        response_type: "code",
      }
    );
  };

  useEffect(() => {
    window.fbAsyncInit = () => {
      window.FB.init({
        appId: process.env.REACT_APP_FACEBOOK_APP_ID,
        autoLogAppEvents: true,
        cookie: true,
        xfbml: true,
        version: "v17.0",
      });

      window.FB.AppEvents.logPageView();
    };
    // eslint-disable-next-line func-names
    (function (d, s, id) {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    })(document, "script", "facebook-jssdk");
  }, []);

  if (isLoadingFacebookPages) {
    return (
      <div className="h-screen w-scren flex flex-col items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (connectedFacebookPages?.length > 0) {
    return (
      <div className="flex flex-col container py-8 md:py-12 mx-auto w-full">
        <div className="mx-auto mb-8 flex flex-row justify-between items-center space-x-4">
          <Link to="/account">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className="mr-4 cursor-pointer"
            >
              <path
                d="M7.828 11H20V13H7.828L13.192 18.364L11.778 19.778L4 12L11.778 4.22198L13.192 5.63598L7.828 11Z"
                fill="#1A1A1A"
              />
            </svg>
          </Link>
          <h2>Congratulations! You have connected your Facebook pages.</h2>
        </div>
        <div className="flex flex-col">
          <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div className="overflow-hidden">
                <table className="min-w-full text-left text-sm font-light">
                  <thead className="border-b font-medium dark:border-neutral-500">
                    <tr>
                      <th scope="col" className="px-6 py-4">
                        #
                      </th>
                      <th scope="col" className="px-6 py-4">
                        Name
                      </th>
                      <th scope="col" className="px-6 py-4">
                        Category
                      </th>
                      <th scope="col" className="px-6 py-4">
                        Link
                      </th>
                      <th scope="col" className="px-6 py-4">
                        Connection Date
                      </th>
                      {/* <th scope="col" className="px-6 py-4">
                        Actions
                      </th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {connectedFacebookPages.map((page, index) => (
                      <tr key={page.id}>
                        <td className="whitespace-nowrap px-6 py-4">
                          {index + 1}
                        </td>
                        <td className="whitespace-nowrap px-6 py-4">
                          {page.name}
                        </td>
                        <td className="whitespace-nowrap px-6 py-4">
                          {page.page_category}
                        </td>
                        <td className="whitespace-nowrap px-6 py-4">
                          <a
                            href={page.fb_page_link}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-500 hover:text-blue-800 hover:underline"
                          >
                            {page.name}
                          </a>
                        </td>
                        <td className="whitespace-nowrap px-6 py-4">
                          {new Date(page.updated_at).toDateString()}
                        </td>
                        {/* <td>
                          <Button type="button" className="w-max" size="sm">
                            Unlink
                          </Button>
                        </td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-row items-center mt-12 md:mt-24">
          <hr className="w-full" />
          <span className="mx-8">OR</span>
          <hr className="w-full" />
        </div>
        <div className="flex flex-col py-8 md:py-12">
          <h3 className="font-semibold text-center my-4 md:my-8">
            Connect New Facebook Account
          </h3>
          <button
            type="button"
            className="mt-2"
            aria-label="Continue with Facebook"
            style={{
              borderRadius: "4px",
              fontSize: "16px",
              height: "40px",
              backgroundColor: "rgb(26, 119, 242)",
              color: "rgb(255, 255, 255)",
              border: "0px none",
              fontWeight: "bold",
              display: "flex",
              justifyContent: "center",
              padding: "4px 16px",
              margin: "0 auto",
            }}
            onClick={loginWithFacebook}
          >
            <span
              className="fb_button_label_element fb_button_label"
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <span className="mr-2">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20 10C20 4.47719 15.5228 0 10 0C4.47719 0 0 4.47711 0 10C0 14.9913 3.65687 19.1284 8.4375 19.8785V12.8906H5.89844V10H8.4375V7.79688C8.4375 5.29063 9.93047 3.90625 12.2146 3.90625C13.3088 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.9498 6.5625 11.5625 7.33336 11.5625 8.12422V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3431 19.1284 20 14.9913 20 10Z"
                    fill="white"
                  />
                </svg>
              </span>
              <span>Continue with Facebook</span>
            </span>
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="py-12 px-4 min-h-screen max-w-screen-xl container mx-auto">
      <div className="text-center mb-4 text-[#1A1A1A] space-y-1">
        <h1 className="font-bold text-2xl leading-7">Connect to Facebook</h1>
        <p className="leading-5">
          Easily create lead ads and manage your campaigns directly from Thryve.
        </p>
      </div>
      <div className="flex flex-col space-y-4">
        {data.map((item) => (
          <div className="flex">
            <div className="h-12 w-[48px] rounded-full block bg-[#0061870A] flex justify-center items-center p-4 mr-2">
              {item.icon}
            </div>
            <p className="text-[#667085] leading-5 text-sm">
              {item.description}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-12">
        <button
          type="button"
          className="mt-2"
          aria-label="Continue with Facebook"
          style={{
            borderRadius: "4px",
            fontSize: "16px",
            height: "40px",
            backgroundColor: "rgb(26, 119, 242)",
            color: "rgb(255, 255, 255)",
            border: "0px none",
            fontWeight: "bold",
            display: "flex",
            justifyContent: "center",
            padding: "4px 16px",
            margin: "0 auto",
          }}
          onClick={loginWithFacebook}
        >
          <span
            className="fb_button_label_element fb_button_label"
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <span className="mr-2">
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M20 10C20 4.47719 15.5228 0 10 0C4.47719 0 0 4.47711 0 10C0 14.9913 3.65687 19.1284 8.4375 19.8785V12.8906H5.89844V10H8.4375V7.79688C8.4375 5.29063 9.93047 3.90625 12.2146 3.90625C13.3088 3.90625 14.4531 4.10156 14.4531 4.10156V6.5625H13.1922C11.9498 6.5625 11.5625 7.33336 11.5625 8.12422V10H14.3359L13.8926 12.8906H11.5625V19.8785C16.3431 19.1284 20 14.9913 20 10Z"
                  fill="white"
                />
              </svg>
            </span>
            <span>Continue with Facebook</span>
          </span>
        </button>
        <div className="text-center text-sm leading-5 font-medium mt-4">
          <p className="text-[#6D7789]">
            Prefer to post your ads via Thryve’s ad account?
          </p>
          <button
            type="button"
            className="text-primary-50"
            onClick={() => navigate("/account")}
          >
            Skip this step
          </button>
        </div>
      </div>
    </div>
  );
}
